import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-content-container overflow-hidden" }
const _hoisted_2 = { class: "row justify-content-center" }
const _hoisted_3 = { class: "col-xxl-6" }
const _hoisted_4 = { class: "col-xxl-6" }
const _hoisted_5 = { class: "row justify-content-center" }
const _hoisted_6 = { class: "col-lg-4 col-sm-4" }
const _hoisted_7 = { class: "col-lg-4 col-sm-4" }
const _hoisted_8 = { class: "col-lg-4 col-sm-4" }
const _hoisted_9 = { class: "row justify-content-center" }
const _hoisted_10 = { class: "col-xxl-7 col-lg-6" }
const _hoisted_11 = { class: "col-xxl-5 col-lg-6" }
const _hoisted_12 = { class: "row justify-content-center" }
const _hoisted_13 = { class: "col-xxl-4" }
const _hoisted_14 = { class: "col-xxl-4 col-md-6" }
const _hoisted_15 = { class: "col-xxl-4 col-md-6" }
const _hoisted_16 = { class: "row justify-content-center" }
const _hoisted_17 = { class: "col-lg-4" }
const _hoisted_18 = { class: "col-lg-4" }
const _hoisted_19 = { class: "col-lg-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WelcomeDashboard = _resolveComponent("WelcomeDashboard")!
  const _component_TotalCourses = _resolveComponent("TotalCourses")!
  const _component_TotalEnrolled = _resolveComponent("TotalEnrolled")!
  const _component_TotalMentors = _resolveComponent("TotalMentors")!
  const _component_StudentsInterestedTopicsChart = _resolveComponent("StudentsInterestedTopicsChart")!
  const _component_TopInstructors = _resolveComponent("TopInstructors")!
  const _component_StudentsProgress = _resolveComponent("StudentsProgress")!
  const _component_GroupLessons = _resolveComponent("GroupLessons")!
  const _component_EnrolledByCountries = _resolveComponent("EnrolledByCountries")!
  const _component_Courses = _resolveComponent("Courses")!
  const _component_CoursesSalesChart = _resolveComponent("CoursesSalesChart")!
  const _component_TimeSpentChart = _resolveComponent("TimeSpentChart")!
  const _component_OurTopCourses = _resolveComponent("OurTopCourses")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_WelcomeDashboard)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_TotalCourses)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_TotalEnrolled)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_TotalMentors)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_StudentsInterestedTopicsChart)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_TopInstructors)
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_StudentsProgress)
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createVNode(_component_GroupLessons)
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_component_EnrolledByCountries)
      ])
    ]),
    _createVNode(_component_Courses),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _createVNode(_component_CoursesSalesChart)
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createVNode(_component_TimeSpentChart)
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createVNode(_component_OurTopCourses)
      ])
    ])
  ]))
}